//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("cancelClearance", CancelClearanceFactory);

    CancelClearanceFactory.$inject = ["apiClientFactory"];
    function CancelClearanceFactory(apiClientFactory) {

        const routePrefix = "api/Clearances/CancelClearance/";

        return {
            CreateOrUpdateCancelClearanceReason: apiClientFactory.post(routePrefix + "CreateOrUpdateCancelClearanceReason/"),
            DeleteCancelClearanceReason: apiClientFactory.post(routePrefix + "DeleteCancelClearanceReason/"),
            GetCancelClearanceReasonForEdit: apiClientFactory.post(routePrefix + "GetCancelClearanceReasonForEdit/"),
            GetCancelClearanceReasons: apiClientFactory.post(routePrefix + "GetCancelClearanceReasons/"),
            GetCancelClearanceReasonsOverviewPaged: apiClientFactory.post(routePrefix + "CancelClearanceReasonsOverviewPaged/"),
        };
    }
})();
